import * as React from 'react';
import { SVGProps } from 'react';

const IconCrownSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 10H2v1h8v-1zm0-1H2L1 4l3 1 2-4 2 4 3-1-1 5z" />
  </svg>
);
export default IconCrownSizeXs;
